import { DropdownOption } from 'components/dropdown/component'
import * as Flash from 'components/flash'
import { ScoutIcon } from 'components/icons/scout'
import { ScoutLargeIcon } from 'components/icons/scout-large'
import { Loading } from 'components/loading'
import * as Validation from 'components/validation/validations'
import { RasaContext } from 'context'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import { Dataset } from 'generic/dataset'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import { isTruthy, tryParseJSON } from 'generic/utility'
import * as GA from 'google-analytics'
import { trim } from 'lodash'
import React from 'react'
import * as GenerativeAI from 'shared_server_client/types/generative_ai'
import { isInCutoffWindow } from 'shared/data-layer/issues'
import { NORMAL_BOOSTED_BOOST_LEVEL } from 'shared_server_client/constants'

import { defaultTopicPropmts, Prompt, AI_BRAND_NAME } from './constants'
import * as Constants from './constants'
import { streamArticleResponse, streamChatResponse } from './data'
import './_styles.scss'

import { PaperPlaneIcon } from "../../icons/paper-plane";
import { Article } from '../types'
import { ChatUtils } from '../shared/chatUtils'

import * as GenerateTextData from 'components/generate-text/data'

declare const RASA_IMAGE_API_ENDPOINT: string
const ModelTypeOptions: DropdownOption[] = [
  { description: 'default', key: '' },
  { description: 'mistral-tiny', key: 'mistral|mistral-tiny' },
  { description: 'mistral-small', key: 'mistral|mistral-small' },
  { description: 'openai-3.5', key: 'openai|gpt-3.5-turbo' },
  { description: 'openai-4.0', key: 'openai|gpt-4-1106-preview' },
]

interface State {
  aiChatSessions: any[],
  aiConfirmationType?: Constants.AIConfirmationType,
  activeCommunity: any,
  articles: Article[],
  categories: GenerativeAI.Keyword[],
  chatInputPlaceholder: string,
  community: string,
  confirm: boolean,
  error?: string,
  found: boolean,
  input: string,
  isChatHistoryLoading: boolean,
  isLoading: boolean,
  message: string,
  newPrompts: GenerativeAI.ChatPrompt[],
  topics: string,
  person: any,
  sessionId: string,
  summary: string,
  showDefaultPrompt: boolean,
  showStreamLoader: boolean,
  streamMessage: string,
  suggestedArticles: Article[],
  model: DropdownOption,
  prompt: string,
  prompts: GenerativeAI.ChatPrompt[],
  aiJsonResponse: string,
  pickStreamKey: boolean,
  currentStreamKey: string,
  showConfirmationPrompts: boolean,
  showsummaryStream: boolean,
  showsuggestedArticlesStream: boolean,
  showpromptStream: boolean,
  // New UI state
  sidebarCollapsed: boolean,
  isTyping: boolean,
  quickActions: string[],
  userPreferences: any,
}

const newState: State = {
  aiChatSessions: [],
  aiConfirmationType: null,
  activeCommunity: {},
  articles: [],
  categories: [],
  chatInputPlaceholder: `Ask ${AI_BRAND_NAME} anything about content discovery...`,
  community: '',
  confirm: false,
  found: true,
  isChatHistoryLoading: false,
  isLoading: false,
  input: '',
  message: '',
  newPrompts: [],
  topics: '',
  sessionId: '',
  summary: '',
  aiJsonResponse: '',
  person: {},
  showDefaultPrompt: true,
  showStreamLoader: false,
  streamMessage: '',
  suggestedArticles: [],
  model: ModelTypeOptions[0],
  prompt: '',
  prompts: [],
  pickStreamKey: false,
  currentStreamKey: '',
  showConfirmationPrompts: false,
  showsummaryStream: true,
  showsuggestedArticlesStream: true,
  showpromptStream: true,
  // New UI state
  sidebarCollapsed: false,
  isTyping: false,
  quickActions: ['Find trending articles', 'Suggest content topics', 'Search by keyword', 'Get help with sourcing'],
  userPreferences: {},
}

export class AnalyzeContentComponentClass extends RasaReactComponent<any, State> {
  public chatEndRef;
  public chatInputRef;
  public static contextType = RasaContext;
  constructor(props: any) {
    super(props, 'communitySource', newState)
    this.sendMessage = this.sendMessage.bind(this)
    this.handleOnEnter = this.handleOnEnter.bind(this)
    this.chatEndRef = React.createRef()
    this.chatInputRef = React.createRef()
  }

  public componentDidMount = () => {
    this.context.user.init().then(({person, activeCommunity}) => {
      this.setState({
        activeCommunity,
        person,
        community: activeCommunity.communityId,
      }, () => {
        this.initialize()
      })
    })
  }

  public render = () => {
    return (
      <div className="rex-modern-wrapper">
        {/* Modern Sidebar */}
        <div className={`rex-sidebar ${this.state.sidebarCollapsed ? 'collapsed' : ''}`}>
          <div className="rex-sidebar-header">
            <button
              className="rex-sidebar-toggle"
              onClick={() => this.setState({sidebarCollapsed: !this.state.sidebarCollapsed})}
            >
              <i className={`fas ${this.state.sidebarCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`} />
            </button>
          </div>
          
          {/* New Chat Button */}
          <div className="rex-new-chat-section">
            <button className="rex-new-chat-btn" onClick={this.clearChat}>
              <i className="fas fa-plus" />
              {!this.state.sidebarCollapsed && <span>New Chat</span>}
            </button>
          </div>
          
          {/* Chat History */}
          <div className="rex-chat-history">
            {!this.state.sidebarCollapsed && <h3>Recent Conversations</h3>}
            <div className="rex-chat-list">
              {this.state.aiChatSessions.length ? this.state.aiChatSessions.map((session, index) => {
                return (
                  <div 
                    className={`rex-chat-item ${this.state.sessionId === session.session_id ? 'active' : ''}`} 
                    key={index} 
                    onClick={() => this.getChatHistory(session.session_id)}
                    title={this.state.sidebarCollapsed ? session.title : ''}
                  >
                    <i className="fas fa-comment" />
                    {!this.state.sidebarCollapsed && <span className="rex-chat-title">{session.title}</span>}
                  </div>
                )
              }) : (
                !this.state.sidebarCollapsed && <div className="rex-no-chats">No previous chats</div>
              )}
            </div>
          </div>
          
          {/* Settings - Theme toggle removed */}
          <div className="rex-sidebar-footer">
            {/* Theme toggle removed per user request */}
          </div>
        </div>
        
        {/* Main Chat Area */}
        <div className="rex-main-content">
          {this.state.isChatHistoryLoading ? (
            <div className="rex-loading-container">
              <Loading size="32" />
              <p>Loading conversation...</p>
            </div>
          ) : (
            <>
              {/* Chat Header */}
              <div className="rex-chat-header">
                <div className="rex-header-info">
                  <div className="rex-header-icon">
                    <ScoutLargeIcon width="64" height="64" />
                  </div>
                  <div className="rex-header-text">
                    <h1>Content Assistant</h1>
                    <p>Your AI-powered content discovery companion</p>
                  </div>
                </div>
                <div className="rex-model-selector">
                  {/* Model selection could go here */}
                </div>
              </div>
              
              {/* Chat Messages */}
              <div className="rex-chat-container" ref={this.chatEndRef}>
                {/* Welcome Message & Quick Actions */}
                {this.state.showDefaultPrompt && this.state.prompts.length === 0 && (
                  <div className="rex-welcome-section">
                    <div className="rex-welcome-message">
                      <ScoutIcon svgwidth="40" svgheight="40"/>
                      <div>
                        <h2>Hi there! I'm {AI_BRAND_NAME} 🔍</h2>
                        <p>I can help you discover amazing content, find trending articles, and curate the perfect newsletter. What would you like to explore today?</p>
                      </div>
                    </div>
                    
                    <div className="rex-quick-actions">
                      <h3>Quick Actions</h3>
                      <div className="rex-action-grid">
                        {this.state.quickActions.map((action, index) => (
                          <button 
                            key={index} 
                            className="rex-action-btn"
                            onClick={() => {
                              this.setState({ message: action }, () => {
                                this.sendMessage()
                              })
                            }}
                          >
                            {action}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    {defaultTopicPropmts(this.state.topics).length > 0 && (
                      <div className="rex-suggested-prompts">
                        <h3>Suggested Questions</h3>
                        <div className="rex-prompt-list">
                          {defaultTopicPropmts(this.state.topics).map((prompt, index) => (
                            <button 
                              key={index} 
                              className="rex-prompt-btn"
                              onClick={() => this.executePrompt(prompt)}
                            >
                              {prompt.content}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                
                {/* Chat Messages */}
                <div className="rex-messages">
                  {this.state.prompts.map((prompt, index) => (
                    <div key={index} className={`rex-message ${prompt.role === Constants.PROMPT_ROLE.USER ? 'user' : 'assistant'}`}>
                      <div className="rex-message-avatar">
                        {prompt.role === Constants.PROMPT_ROLE.USER ? (
                          <i className="fas fa-user" />
                        ) : (
                          <ScoutIcon svgwidth="24" svgheight="24"/>
                        )}
                      </div>
                      <div className="rex-message-content">
                        {this.buildPrompt(prompt)}
                      </div>
                    </div>
                  ))}
                  
                  {/* Dynamic Content Sections */}
                  {this.state.articles.length > 0 && (
                    <div className="rex-message assistant">
                      <div className="rex-message-avatar">
                        <ScoutIcon svgwidth="24" svgheight="24"/>
                      </div>
                      <div className="rex-message-content">
                        {this.buildArticlesPrompt(this.state)}
                      </div>
                    </div>
                  )}
                  
                  {this.state.summary && this.state.showsummaryStream && (
                    <div className="rex-message assistant">
                      <div className="rex-message-avatar">
                        <ScoutIcon svgwidth="24" svgheight="24"/>
                      </div>
                      <div className="rex-message-content">
                        {this.buildSummaryPrompt(this.state)}
                      </div>
                    </div>
                  )}
                  
                  {this.state.suggestedArticles.length > 0 && this.state.showsuggestedArticlesStream && (
                    <div className="rex-message assistant">
                      <div className="rex-message-avatar">
                        <ScoutIcon svgwidth="24" svgheight="24"/>
                      </div>
                      <div className="rex-message-content">
                        {this.buildSuggestedArticlesPrompt(this.state)}
                      </div>
                    </div>
                  )}
                  
                  {this.state.prompt && (
                    <div className="rex-message assistant">
                      <div className="rex-message-avatar">
                        <ScoutIcon svgwidth="24" svgheight="24"/>
                      </div>
                      <div className="rex-message-content">
                        <p>{this.state.prompt}</p>
                        {this.state.showConfirmationPrompts && (
                          <div className="rex-confirmation-actions">
                            <button onClick={this.suggestContent} className="rex-confirm-btn primary">Yes, continue</button>
                            <button onClick={this.exploreMore} className="rex-confirm-btn secondary">{Constants.EXPLORE_MORE_PROMPT.content}</button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  {/* Typing Indicator */}
                  {(this.state.showStreamLoader || this.state.isTyping) && (
                    <div className="rex-message assistant">
                      <div className="rex-message-avatar">
                        <ScoutIcon svgwidth="24" svgheight="24"/>
                      </div>
                      <div className="rex-message-content">
                        <div className="rex-typing-indicator">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Input Area */}
              <div className="rex-input-container">
                <form className="rex-input-form" onSubmit={(e) => { e.preventDefault(); this.sendMessage(); }}>
                  <div className="rex-input-wrapper">
                    <input 
                      type="text" 
                      ref={this.chatInputRef}
                      value={this.state.message}
                      onChange={(e) => this.setState({message: e.target.value})}
                      onKeyDown={this.handleOnEnter}
                      placeholder={this.state.chatInputPlaceholder}
                      className="rex-message-input"
                      disabled={this.state.isLoading || this.state.showStreamLoader}
                    />
                    <button 
                      type="submit"
                      className="rex-send-btn"
                      disabled={!this.state.message || !this.state.message.trim() || this.state.isLoading || this.state.showStreamLoader}
                    >
                      <PaperPlaneIcon />
                    </button>
                  </div>
                </form>
                <div className="rex-input-footer">
                  <small>Scout is powered by AI and may make mistakes. Please verify important information.</small>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    )
  }

  private buildPrompt = (prompt) => {
    const promptJson = tryParseJSON(prompt.content)
    if (promptJson.summary) {
      return this.buildSummaryPrompt(promptJson)
    } else if (promptJson.articles && promptJson.articles.length > 0) {
      return this.buildArticlesPrompt(promptJson)
    } else if (promptJson.suggestedArticles && promptJson.suggestedArticles.length > 0) {
      return this.buildSuggestedArticlesPrompt(promptJson)
    } else {
      return this.buildMessagePrompt(prompt)
    }
  }

  private buildSuggestedArticlesPrompt = (prompt) => {
    return (
      <div className="rex-suggested-articles">
        <div className="rex-articles-header">
          <h3>✨ Found some great articles for you!</h3>
          <p>Would you like me to add {prompt.suggestedArticles.length > 1 ? 'these articles' : 'this article'} to your content pool?</p>
        </div>
        <div className="rex-articles-grid">
          {prompt.suggestedArticles.map((article, index) => this.renderModernArticle(article, index))}
        </div>
        <div className="rex-bulk-actions">
          <button 
            onClick={() => {
              const allPostIds = prompt.suggestedArticles.map(article => article.post_id).join(',')
              this.logChatHistory(`Add all articles to upcoming: ${prompt.suggestedArticles.length} articles`, Constants.PROMPT_ROLE.USER)
              this.moveContentToUpcoming(allPostIds, 'bulk')
            }}
            className="rex-bulk-btn primary"
          >
            Add All to Upcoming
          </button>
        </div>
      </div>
    )
  }

  private buildMessagePrompt = (prompt) => {
    const promptJson = tryParseJSON(prompt.content)
    
    // Handle enhanced response format from templates
    const isEnhancedResponse = promptJson && promptJson.originalMessage !== undefined
    const displayContent = isEnhancedResponse ? promptJson.originalMessage : prompt.content
    const responseData = isEnhancedResponse ? promptJson : promptJson
    
    return (
      <div className="rex-message-text">
        <p dangerouslySetInnerHTML={{__html: this.convertTextToLinks(displayContent)}}></p>
        
        
        {/* Enhanced template response handling */}
        {responseData && responseData.suggestedActions && responseData.suggestedActions.length > 0 && (
          <div className="rex-suggested-actions">
            <h4>💡 Suggested Actions:</h4>
            <div className="rex-action-buttons">
              {responseData.suggestedActions.map((action, index) => (
                <button 
                  key={index}
                  className="rex-suggested-action-btn"
                  onClick={() => {
                    this.setState({ message: action }, () => {
                      this.sendMessage()
                    })
                  }}
                >
                  {action}
                </button>
              ))}
            </div>
          </div>
        )}
        
        {/* Confidence indicator */}
        {responseData && responseData.confidence && (
          <div className="rex-confidence-indicator">
            <small>
              <i className={`fas ${this.getConfidenceIcon(responseData.confidence)}`} />
              Confidence: {responseData.confidence}
            </small>
          </div>
        )}
        
      </div>
    )
  }

  private buildSummaryPrompt = (prompt) => {
    return (
      <div className="rex-summary-card">
        <div className="rex-summary-header">
          <h3>📋 Content Summary</h3>
        </div>
        <div className="rex-summary-content">
          <p>{prompt.summary}</p>
        </div>
        {prompt.topics && prompt.topics.length > 0 && (
          <div className="rex-topics-section">
            <h4>🏷️ Related Topics</h4>
            <div className="rex-topics-list">
              {prompt.topics.split(',').map((topic: string, index: number) => (
                <span key={index} className="rex-topic-tag">
                  {topic.trim()}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }

  private buildArticlesPrompt = (prompt) => {
    return (
      <div className="rex-articles-section">
        <div className="rex-articles-header">
          <h3>📰 Perfect articles for your newsletter</h3>
          <p>I found {prompt.articles.length} article{prompt.articles.length > 1 ? 's' : ''} that match your criteria</p>
        </div>
        <div className="rex-articles-grid">
          {prompt.articles.map((article, index) => this.renderModernArticle(article, index))}
        </div>
        <div className="rex-article-actions">
          <button onClick={this.suggestMoreContent} className="rex-action-btn secondary">
            <i className="fas fa-plus" /> Show More Articles
          </button>
          {prompt.articles.length > 1 && (
            <button 
              onClick={() => {
                this.logChatHistory(Constants.ADD_ALL_ARTICLES_PROMPT, Constants.PROMPT_ROLE.USER)
                this.moveContentToUpcoming(prompt.articles.map((article) => article.post_id).join(','), 'bulk')
              }}
              className="rex-action-btn primary"
            >
              <i className="fas fa-plus-circle" /> Add All to Upcoming
            </button>
          )}
        </div>
      </div>
    )
  }
  
  private renderModernArticle = (article, index) => {
    return (
      <div className="rex-modern-article-card rex-compact-layout" key={article.post_id || index}>
        <div className="rex-article-image rex-compact-image">
          {article.hosted_image_url ? (
            <img src={article.hosted_image_url} alt={article.title} />
          ) : (
            <div className="rex-article-placeholder">
              <i className="fas fa-newspaper" />
            </div>
          )}
        </div>
        <div className="rex-article-content rex-compact-content">
          <div className="rex-article-meta">
            {article.site_name && <span className="rex-article-source">{article.site_name}</span>}
            {article.created && <span className="rex-article-date">{new Date(article.created).toLocaleDateString()}</span>}
          </div>
          <h4 className="rex-article-title">
            <a href={article.url} target="_blank" rel="noopener noreferrer">
              {article.title || "Untitled Article"}
            </a>
          </h4>
          <p className="rex-article-description">
            {article.description && article.description.length > 150
              ? `${article.description.substring(0, 150)}...`
              : article.description || "No description available for this article."
            }
          </p>
          <div className="rex-article-actions">
            <button 
              className="rex-article-btn primary"
              onClick={() => {
                this.logChatHistory(`Add article to upcoming: "${article.title}"`, Constants.PROMPT_ROLE.USER)
                this.moveContentToUpcoming(article.post_id, 'single')
              }}
            >
              <i className="fas fa-plus" /> Add to Upcoming
            </button>
            <button 
              className="rex-article-btn secondary"
              onClick={() => window.open(article.url, '_blank')}
            >
              <i className="fas fa-external-link-alt" /> Read
            </button>
          </div>
        </div>
      </div>
    )
  }



  private suggestContent = () => {
    if (this.state.summary) {
      this.setState({
        showStreamLoader: true,
        showConfirmationPrompts: false,
      })
      const payload = {
        topics: this.state.topics,
        summary: this.state.summary,
        session_id: this.state.sessionId,
      }
      streamArticleResponse(this.state.community, payload, this.updateArticleResponse)
    } else {
      this.streamText(Constants.REX_COULD_NOT_FIND_MSG)
    }
  }

  private suggestMoreContent = () => {
    this.setState({
      showStreamLoader: true,
    })
    this.logChatHistory(Constants.SHOW_MORE_ARTICLES_PROMPT, Constants.PROMPT_ROLE.USER).then(() => {
      const payload = {
        session_id: this.state.sessionId,
      }
      streamArticleResponse(this.state.community, payload, this.updateArticleResponse, true)
    }).catch(() => {
      this.setState({
        showStreamLoader: false,
      }, () => {
        this.streamText(Constants.REX_COULD_NOT_FIND_MSG)
      })

    })
  }

  private exploreMore = () => {
    this.setState({
      prompt: '',
      prompts: [
        ...this.state.prompts,
        {
          role: Constants.PROMPT_ROLE.ASSISTANT,
          content: `${this.state.prompt}`,
        }
      ],
    }, () => {
      this.scrollToBottom()
    })
    this.executePrompt(Constants.EXPLORE_MORE_PROMPT)
  }

  private scrollToBottom = () => {
    // Use setTimeout to ensure DOM updates are complete
    setTimeout(() => {
      if (this.chatEndRef && this.chatEndRef.current) {
        this.chatEndRef.current.scrollTop = this.chatEndRef.current.scrollHeight;
      }
    }, 100);
  }

  protected validInput(): boolean {
    return Validation.validateForgivingUrl(this.state.input).valid || Validation.validateDomain(this.state.input).valid
  }

  protected handleOnEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.sendMessage()
    }
  }

  protected sendMessage = (message: string = "") => {
     this.context.store.dispatch(GA.sendGa4Event(this.ga4Event(GA.EventNames.TRexQuestion)))
    this.setState({
      newPrompts: [
        ...this.state.newPrompts,
        {
          role: Constants.PROMPT_ROLE.USER,
          content: message ? message : this.state.message,
        }
      ],
      prompts:
        [
          ...this.state.prompts,
          {
            role: Constants.PROMPT_ROLE.USER,
            content: message ? message : this.state.message,
          }
        ],
      prompt: '',
      showConfirmationPrompts: false,
      message: '',
      showStreamLoader: true,
      showDefaultPrompt: false,
      chatInputPlaceholder: '',
    }, () => {
      // Enhanced payload with template context
      const enhancedPayload = {
        prompts: this.state.newPrompts,
        session_id: this.state.sessionId,
        requires_confirmation: this.state.aiConfirmationType !== null,
        // Additional context for templates
        conversationHistory: this.state.prompts.slice(-5), // Last 5 messages
        userPreferences: {
          topics: this.state.topics ? this.state.topics.split(',') : [],
          // Add any other user preferences from state
        },
        additionalContext: {
          activeCommunity: this.state.activeCommunity,
          currentTopics: this.state.topics,
          sessionContext: {
            hasArticles: this.state.articles.length > 0,
            hasSuggestedArticles: this.state.suggestedArticles.length > 0,
            hasSummary: isTruthy(this.state.summary)
          }
        }
      }
      
      streamChatResponse(this.state.community, enhancedPayload, 'suggest-content', this.updateChatMessage)
      this.scrollToBottom()
    })
  }

  private executePrompt = (prompt: Prompt) => {
    // if prompt has some placeholder it means it requires user's input
    if (prompt.placeholder) {
      this.setState({
        prompts:
          [
            ...this.state.prompts,
            {
              role: prompt.role,
              content: prompt.content,
            }
          ],
        newPrompts: [
          ...this.state.newPrompts,
          {
            role: prompt.role,
            content: prompt.content,
          }
        ],
        chatInputPlaceholder: prompt.placeholder,
        showDefaultPrompt: false,
      })
      this.chatInputRef.current.focus()
    } else {
      this.setState({
        showDefaultPrompt: false,
      })
      this.sendMessage(prompt.content)
    }
  }

  private updateChatMessage: GenerativeAI.ChatCallback = (response: GenerativeAI.ChatResponse) => {
    if (!response) {
      this.setState({
        isSaving: false,
        newPrompts: [],
        isTyping: false,
      })
    } else {
      // Handle typing indicator
      if (response.typing !== undefined) {
        this.setState({
          isTyping: response.typing
        })
        return
      }
      
      if (response.done || response.error) {
        if (response.session_id) {
          this.setState({
            sessionId: response.session_id,
          })
        }
        let jsonString = response.message
        let aiJsonResponse = tryParseJSON(response.message)
        if (Object.keys(aiJsonResponse).length || this.state.aiJsonResponse) {
          if (Object.keys(aiJsonResponse).length === 0) {
            this.streamJson(response.message)
            jsonString = this.state.aiJsonResponse + response.message
            aiJsonResponse = tryParseJSON(jsonString)
          }
          if (aiJsonResponse && Object.keys(aiJsonResponse).length > 0) {
            if (isTruthy(aiJsonResponse.confirm) && this.state.aiConfirmationType !== null) {
              this.takeConfirmationAction(aiJsonResponse.confirm)
              return
            }
            if (aiJsonResponse.suggestedArticles && aiJsonResponse.suggestedArticles.length > 0) {
              this.setState({
                aiConfirmationType: Constants.AIConfirmationType.ARTICLE_ADD,
                suggestedArticles: aiJsonResponse.suggestedArticles,
                showsuggestedArticlesStream: false,
                prompts: [
                  ...this.state.prompts,
                  {
                    role: Constants.PROMPT_ROLE.ASSISTANT,
                    content: jsonString,
                  }
                ],
                aiJsonResponse: '',
                showStreamLoader: false,
              })
            } else if (aiJsonResponse.article) {
              this.updateArticleResponse(response)
            } else if (aiJsonResponse.summary) {
              this.setState({
                prompts: [
                  ...this.state.prompts,
                  {
                    role: Constants.PROMPT_ROLE.ASSISTANT,
                    content: jsonString,
                  },
                ],
                aiJsonResponse: '',
                aiConfirmationType: Constants.AIConfirmationType.ARTICLE_SUGGESTION_REQUEST,
                summary: aiJsonResponse.summary,
                topics: aiJsonResponse.topics,
                showsummaryStream: false,
                showStreamLoader: false,
              }, () => {
                this.scrollToBottom()
                this.streamSummaryConfirmation()
              })
            } else if (aiJsonResponse.prompt) {
                this.setState({
                  prompts: [
                    ...this.state.prompts,
                    {
                      role: Constants.PROMPT_ROLE.ASSISTANT,
                      content: aiJsonResponse.prompt,
                    }
                  ],
                  aiJsonResponse: '',
                  showpromptStream: false,
                  showStreamLoader: false,
                })
              } else {
                this.setState({
                  aiJsonResponse: '',
                  showStreamLoader: false,
                })
                this.streamText(Constants.REX_COULD_NOT_FIND_MSG)
              }
            } else {
              this.setState({
                aiJsonResponse: '',
                showStreamLoader: false,
              })
              this.streamText(Constants.REX_COULD_NOT_FIND_MSG)
            }
        } else {
          // Enhanced handling for template responses
          let enhancedContent = this.state.prompt + response.message
          
          // If the response has enhanced fields, incorporate them
          if (response.suggestedActions || response.confidence || response.intent) {
            const enhancedResponse = {
              originalMessage: enhancedContent,
              suggestedActions: response.suggestedActions || [],
              confidence: response.confidence,
              intent: response.intent,
              templateUsed: response.templateUsed
            }
            enhancedContent = JSON.stringify(enhancedResponse)
          }
          
          this.setState({
            prompts: [
              ...this.state.prompts,
              {
                role: Constants.PROMPT_ROLE.ASSISTANT,
                content: enhancedContent,
              }
            ],
            showStreamLoader: false,
          })
        }
        this.setState({
          isSaving: false,
          error: response.error,
          prompt: '',
          newPrompts: [],
        })
      } else {
        if (response.message) {
          const aiJsonResponse = tryParseJSON(response.message)
          if (aiJsonResponse.article) {
            this.updateArticleResponse(response)
          } else if (trim(response.message).startsWith('{') || this.state.aiJsonResponse) {
            this.streamJson(response.message)
            this.setState({
              aiJsonResponse: this.state.aiJsonResponse + response.message,
              showStreamLoader: false,
            })
          } else {
            this.setState({
              prompt: this.state.prompt + response.message,
              showStreamLoader: false,
            })
          }
        }
      }
      this.scrollToBottom()
    }
  }

  private updateArticleResponse: GenerativeAI.ChatCallback = (response: GenerativeAI.ChatResponse) => {
    if ( !response ) {
      this.setState({
        isSaving: false,
        showDefaultPrompt: false,
        showStreamLoader: false,
        chatInputPlaceholder: '',
        aiConfirmationType: null,
      })
    } else {
      const articleJson = tryParseJSON(response.message)
      if (Object.keys(articleJson).length) {
        if (response.done) {
          const articles = [
            ...this.state.articles,
            articleJson.article,
          ]
          this.setState({
            prompts: [
              ...this.state.prompts,
              {
                role: Constants.PROMPT_ROLE.ASSISTANT,
                content: JSON.stringify({
                  articles
                }),
              },
            ],
            articles: [],
          }, () => {
            this.scrollToBottom()
          })
        } else {
          this.setState({
            articles: [
              ...this.state.articles,
              articleJson.article,
            ],
            isSaving: false,
            showStreamLoader: false,
          }, () => {
            this.scrollToBottom()
          })
        }
      } else {
        this.updateChatMessage(response)
      }
      this.scrollToBottom()
    }
  }

  private moveContentToUpcoming = (post_ids, actionType = 'single') => {
    this.context.store.dispatch(GA.sendGa4Event(this.ga4Event(GA.EventNames.TRexAddArticle)))
    this.setState({
      isLoading: true,
      showStreamLoader: true,
    })
    return this.context.entityMetadata.getEntityObject('communityArticle').then((entity) => {
      entity.setRecordId(this.state.activeCommunity.communityId, null);
      entity.data.post_ids = post_ids.toString()
      if (isInCutoffWindow(this.state.activeCommunity.nextIssue)) {
        entity.data.boost_level = NORMAL_BOOSTED_BOOST_LEVEL
        entity.data.created = this.state.activeCommunity.nextIssue.cutoff
      }
      return entity.save()
        .then(() => {
          this.setState({
            isLoading: false,
          })
          this.setState({
            suggestedArticles: [],
            aiConfirmationType: null,
            showStreamLoader: false
          })
          
          // Show appropriate success message based on action type
          const successMessage = this.getSuccessMessage(post_ids, actionType)
          this.streamText(successMessage)
        })
        .catch(() => {
        })
    })
  }

  private getSuccessMessage = (post_ids, actionType) => {
    return ChatUtils.getSuccessMessage(post_ids, actionType, 'article')
  }

  private initialize = () => {
    Promise.all([
      this.getChatSessions(),
      this.getTopics(),
    ])
  }

  private getTopics = () => {
    return GenerateTextData.getTopics(this.state.community)
      .then((topics) => {
        if ( topics ) {
          this.setState({
            showDefaultPrompt: false,
            topics: topics.join(','),
          }, () => this.executePrompt(Constants.defaultTopicPropmts(topics.join(','))[0]))
        }
      })
  }

  private getChatSessions = () => {
    return new Dataset().loadCommunityDataset('aiChatSessions', this.state.community, []).then((aiChatSessions) => {
        if (aiChatSessions[0].length) {
          this.setState({
            aiChatSessions: aiChatSessions[0],
          })
        }
      })
  }

  private getChatHistory = (sessionId) => {
    this.setState({
      sessionId,
      isChatHistoryLoading: true,
    })
    return new Dataset().loadCommunityDataset('aiChatHistory', this.state.community, [{param: 'sessionId', value: sessionId}]).then((aiChatHistory) => {
      if (aiChatHistory[0].length) {
        const prompts = aiChatHistory[0].filter((prompt) => prompt.source !== Constants.CHATSOURCE.FULL_ARTICLES_LIST &&
          (prompt.source === Constants.CHATSOURCE.RECOMMENDATION_ENGINE || JSON.parse(prompt.options).role !== Constants.PROMPT_ROLE.SYSTEM)).map((prompt)=> {
          const jsonContent = tryParseJSON(prompt.prompt)
          let content = jsonContent.prompt ? jsonContent.prompt : prompt.prompt
          const options = tryParseJSON(prompt.options)
          if (prompt.source === Constants.CHATSOURCE.RECOMMENDATION_ENGINE) {
            const articles = tryParseJSON(prompt.prompt)
            content = JSON.stringify({
              articles,
            })

          }
          return {
            role: options.role || Constants.PROMPT_ROLE.ASSISTANT,
            content,
          }
        })
        this.setState({
          isChatHistoryLoading: false,
          prompts,
        }, () => {
          this.scrollToBottom()
        })
      }
    }).catch(() => {
      this.setState({
        isChatHistoryLoading: false,
      })
      this.context.store.dispatch(Flash.showFlashMessage('Unable to fetch chat history. Please try again.'))
    })
  }

  private takeConfirmationAction = (confirm) => {
    if (!isTruthy(confirm)) {
      return
    }
    this.setState({
      prompt: '',
    })
    if (this.state.aiConfirmationType === Constants.AIConfirmationType.ARTICLE_ADD) {
      this.moveContentToUpcoming(this.state.suggestedArticles.map((article) => article.post_id).join(','), 'bulk')
    } else if (this.state.aiConfirmationType === Constants.AIConfirmationType.ARTICLE_SUGGESTION_REQUEST) {
      this.suggestContent()
    }
  }

  private streamJson = (jsonStream: string) => {
    jsonStream = jsonStream
    const pickTriggers = [
      "{",
      " {",
      " { ",
      "{\n",
      "{\"",
      ".\",",
      "?\",",
      "?\",\n",
      ".\",\n",
    ]
    const ignoreStreamData = [
      ...pickTriggers,
      " ",
      '"',
      "",
      "\n",
      "\":",
      '":',
      '"}',
      "\"}",
      " \"",
      ' "',
    ]
    const replaceStreamData = [{
      key: "?\",",
      value: "?",
    }, {
      key: "?\",\n",
      value: "?",
    }]
    if (pickTriggers.includes(jsonStream)) {
      this.setState({
        pickStreamKey: true,
      })
    } else if (ignoreStreamData.includes(jsonStream)) {
      return
    } else {
      if (this.state.pickStreamKey) {
        this.setState({
          ...this.state,
          [`show${this.state.pickStreamKey}Stream`]: true,
          currentStreamKey: jsonStream,
          pickStreamKey: false,
        })
      } else {
        if (this.state.currentStreamKey !== 'prompt' || this.state.aiConfirmationType === null) {
          // replace stream Data
          replaceStreamData.forEach((replaceData) => {
            jsonStream = jsonStream.replace(replaceData.key, replaceData.value)
          })
          this.setState({
            ...this.state,
            showStreamLoader: false,
            [this.state.currentStreamKey]: this.state[this.state.currentStreamKey] + jsonStream,
          }, () => {
            this.scrollToBottom()
          })
        }
      }
    }
  }

  private delay = (ms: number) => {
    return new Promise((resolve) => {
      setTimeout(resolve, ms)
    })
  }

  private streamSummaryConfirmation = () => {
    this.streamText("Hold tight, I'm fetching some stuff for you based on the given summary & topics...", true).then(() => {
      this.scrollToBottom()
      this.suggestContent()
    })
  }

  private convertTextToLinks = (text: string): string => {
    // Regex pattern to match URLs
    const urlPattern = /(\bhttps?:\/\/[^\s/$.?#].[^\s]*)/gi;
    // Regex pattern to match emails
    const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

    // Convert URLs to hyperlinks
    let result = text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');
    // Convert emails to mailto links
    result = result.replace(emailPattern, '<a href="mailto:$1">$1</a>');

    return result;
  }


  private streamText =  (text, addToPrompt = true) => {
    const TEXT_STREAM_DELAY = 100
    const words = text.split(' ')
    this.logChatHistory(text)
    return new Promise((resolve, reject) => {
      return words.forEach((word, index) => {
        this.delay(TEXT_STREAM_DELAY * (index + 1)).then(() => {
          if (index === words.length - 1) {
            resolve(true)
            if (addToPrompt) {
              this.setState({
                prompt: '',
                prompts: [
                  ...this.state.prompts,
                  {
                    role: Constants.PROMPT_ROLE.ASSISTANT,
                    content: `${this.state.prompt} ${word}`,
                  }
                ],
              }, () => {
                this.scrollToBottom()
              })
            } else {
              this.setState({
                prompt: `${this.state.prompt} ${word}`,
              }, () => {
                this.scrollToBottom()
              })
            }
          } else {
            this.setState({
              prompt: `${this.state.prompt} ${word}`,
            }, () => {
              this.scrollToBottom()
            })
          }
        })
      })
    })
  }
  private logChatHistory = (message, role = Constants.PROMPT_ROLE.ASSISTANT) => {
    // This is a fire and forget method we don't care if this fails.
    const url: string = `${AjaxWrapper.getServerUrl()}/ai/${this.state.community}/log-chat-history`
    return AjaxWrapper.ajax(url, HttpMethod.POST, {
      session_id: this.state.sessionId,
      prompt: message,
      role,
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log('Error logging chat history', error)
    })
  }
  private clearChat = () => {
    this.setState({
      ...newState,
      aiChatSessions: this.state.aiChatSessions,
      activeCommunity: this.state.activeCommunity,
      community: this.state.community,
      model: this.state.model,
    }, () => {
      this.getChatSessions()
    })
  }

  private ga4Event = (eventName: string): GA.Event4 => {
    return {
      name: eventName,
      payload: {
        source: 't-rex-chat',
      },
    }
  }

  private getConfidenceIcon = (confidence: string): string => {
    switch (confidence && confidence.toUpperCase()) {
      case 'HIGH':
        return 'fa-check-circle text-success'
      case 'MEDIUM':
        return 'fa-exclamation-circle text-warning'
      case 'LOW':
        return 'fa-question-circle text-muted'
      default:
        return 'fa-info-circle text-info'
    }
  }
}

